export default "__VITE_ASSET__BS2g9W7J__"